import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ResourceRef } from './ResourceRef'
/**
* Class WellKnownProductAttributesDict
*  Значения известных атрибутов, где: <br><br>ключ: системный идентификатор Web.Api.Showcases.Controllers.Attributes.Models.AttributeDto.SystemName; <br><br>значение: типизированное представление значений атрибута<br>
*/
export class WellKnownProductAttributesDict extends ActiveModel {

/**
  * Name
  * 
  */
  @ActiveField('')
  Name: string = ''


  /**
  * Price
  *   */
  @ActiveField(0)
  Price: number = 0


/**
  * Article
  * 
  */
  @ActiveField('')
  Article: string = ''


/**
  * Description
  * 
  */
  @ActiveField()
  Description?: string


  /**
  * SizeTable
  * Информация о файле-ресурсе  */
  @ActiveField({
    factory: [ResourceRef, () => undefined]
  })
  SizeTable?: ResourceRef


/**
  * Barcode
  * 
  */
  @ActiveField()
  Barcode?: string
}
